import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Card, Dropdown, Icon, Button, Popup, Modal} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import VerifyInvoiceSelected from '../verifyInvoice/table';
import './close.scss';

class Close extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'invoiceSelected': '',
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.BinningClose, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchPendingInvoicesToBin('closePending');
  }

  onCloseClick() {
    this.props.closeInvoice(this.state.invoiceSelected);
  }

  getInvoices() {
    const {invoices} = this.props;
    return invoices.map((item) => {
      return {'text': item.invoice, 'value': item.invoice};
    });
  }

  getInvoiceInfo(invoiceSelected) {
    const {invoices} = this.props;
    return _.find(invoices, function(item) {
      return item.invoice === invoiceSelected;
    });
  }

  getOriginName(invoiceSelected) {
    const invoiceInfo = this.getInvoiceInfo(invoiceSelected);
    return invoiceInfo ? ` | ${invoiceInfo.providerOrigin}` : '';
  }

  changeInvoice(value) {
    if (value === this.state.invoiceSelected) {
      return;
    }
    this.setState({'invoiceSelected': value});
    this.props.verifyInvoice(value);
    this.props.changeVerifyInvoiceListPage(0);
    this.props.changeVerifyInvoiceListPageSize(20);
  }

  renderCloseButton() {
    const {invoiceSelected} = this.state;
    const {loadingInvoices, closingInvoice} = this.props;
    if (!invoiceSelected) {
      return (
        <Button
          type='button'
          primary
          className='toyota-primary refresh'
          disabled={loadingInvoices || !invoiceSelected || closingInvoice}
          loading={loadingInvoices}
        >
          Cierre
        </Button>
      );
    }
    
    return (
      <Modal size='mini'
        trigger={
          <span>
            <Button
              type='button'
              primary
              className='toyota-primary refresh'
              disabled={loadingInvoices || !invoiceSelected || closingInvoice}
              loading={loadingInvoices}
            >
              Cierre
            </Button>
          </span>
        }
        header='¿Desea cerrar la factura seleccionada?'
        actions={[
          {'key': 'cancel', 'content': 'Cancelar'},
          {'key': 'done', 'content': 'Confirmar', 'positive': true,
            'onClick': this.onCloseClick.bind(this),
            'primary': true,
          },
        ]}
      />
    );
  }

  render() {
    const {invoiceSelected} = this.state;
    const {
      loadingInvoices, loadingBoxesVerified, totalItems, boxesVerifiedList, closingInvoice,
    } = this.props;
    const invoiceInfo = this.getInvoiceInfo(invoiceSelected) || {};

    return (
      <div className='close-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Binning - Cierre de Facturas</h2>
              <Popup
                trigger={
                  <Icon link name='info circle' color='blue' size='large' />
                }
                on='click'
                position='bottom left'
                inverted
              >
                <div>
                  Cierre de facturas con items pendientes a recibir
                </div>
              </Popup>
              {
                invoiceSelected &&
                <div className='title-bar-actions'>
                  <span className='label'>Factura</span>
                  <span>{invoiceInfo.invoiceQuantity}</span>
                  <span className='label'>Revisión</span>
                  <span>{invoiceInfo.storedQuantity}</span>
                  <span className='label'>Diferencia</span>
                  <span className='difference'>{invoiceInfo.difference}</span>
                </div>
              }
            </div>
            <div className='filters-section'>
              <Dropdown selection
                options={this.getInvoices()}
                search
                value={invoiceSelected}
                disabled={loadingInvoices || closingInvoice}
                loading={loadingInvoices}
                onChange={(e, {value}) => this.changeInvoice(value)}
                placeholder='Seleccione Factura'
              />
              {this.renderCloseButton()}
            </div>
            {
              invoiceSelected &&
              <div className='subtitle'>
                {invoiceInfo.providerName} {this.getOriginName(invoiceSelected)}
              </div>
            }
          </div>
        </Card>
        
        {
          invoiceSelected &&
          <VerifyInvoiceSelected loading={loadingBoxesVerified} invoice={invoiceSelected}
            invoicesList={boxesVerifiedList} totalItems={totalItems} />
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingInvoices': state.close.loadingInvoices,
    'invoices': state.close.listInvoices,
    'loadingBoxesVerified': state.close.loadingBoxesVerified,
    'boxesVerifiedList': state.close.boxesVerifiedListByPage,
    'totalItems': state.close.boxesVerifiedList.length,
    'closingInvoice': state.close.closingInvoice,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  verifyInvoice,
  fetchPendingInvoicesToBin,
  changeVerifyInvoiceListPage,
  changeVerifyInvoiceListPageSize,
  closeInvoice,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  verifyInvoice,
  fetchPendingInvoicesToBin,
  changeVerifyInvoiceListPage,
  changeVerifyInvoiceListPageSize,
  closeInvoice,
})(Close);
